// @flow
import * as React from 'react';
import BaseEditor from 'esm-web-pro/containers/map/editor/BaseEditor';
import type { Map } from 'esm-web-pro/containers/map/types';
import type { Cable as CableType } from 'esm-web-pro/types/networks';
import MapCable from 'esm-web-pro/containers/pages/network/objects/cable/MapCable';
import CablePanel from 'esm-web-pro/containers/pages/network/objects/cable/CablePanel';
import CableEditor from 'esm-web-pro/containers/pages/network/objects/cable/CableEditor';
import PatchCableEditor from 'esm-web-pro/containers/pages/network/objects/cable/patch/PatchCableEditor';
import MapPoint from 'esm-web-pro/containers/pages/network/objects/MapPoint';

type Props = {
    object: CableType,
    map: Map,
    updateObject: Function,
    editor: BaseEditor,
}

const Cable = (props: Props) => {
    const {
        object: cable, map, updateObject, editor,
    } = props;

    const [clicked, setClicked] = React.useState(null);

    return cable.patch ? (
        <MapPoint point={cable.start_container_point} editor={editor}>
            {(handleView) => (
                <CablePanel
                    cable={cable}
                    editor={PatchCableEditor}
                    map={map}
                    mapEditor={editor}
                    handleView={handleView}
                    updateObject={updateObject}
                />
            )}
        </MapPoint>
    ) : (
        <MapCable cable={cable} editor={editor}>
            {(highlightFiber, highlightCable, handleView) => (
                <CablePanel
                    cable={cable}
                    editor={CableEditor}
                    map={map}
                    mapEditor={editor}
                    highlightFiber={highlightFiber}
                    highlightCable={highlightCable}
                    handleView={handleView}
                    clicked={clicked}
                    setClicked={setClicked}
                    updateObject={updateObject}
                />
            )}
        </MapCable>
    );
};

export default Cable;
